import {
	CLOSE_TOAST,
	OPEN_AND_SET_TOAST_CONTENT,
} from "../../actions/constants";

const initialToastState = {
	toastContent: "",
	toastType: "",
	toastStyles: {
		backgroundColor: "#FFFFFF !important",
		border: "2px solid #27AE60",
		borderRadius: "40px 40px 0px 40px",
		fontWeight: 400,
		fontFamily: "Avenir",
		fontStyle: "normal",
		fontSize: "18px",
		lineHeight: "25px",
		color: "#27AE60",
		width: "326px",
		textAlign: "center",
		padding: "10px 0px",
	},
	toastOpened: false,
};

const toastReducer = (state = initialToastState, action: any) => {
	switch (action.type) {
		case CLOSE_TOAST: {
			return { ...state, toastOpened: false };
		}
		case OPEN_AND_SET_TOAST_CONTENT: {
			return {
				...state,
				toastOpened: true,
				toastContent: action.toastContent,
				toastType: action.toastType,
				toastStyles: { ...state.toastStyles, ...action.toastStyles },
			};
		}
		default: {
			return state;
		}
	}
};

export default toastReducer;
